import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { GET_WHITELABELS } from "../../Action/actionTypes";
import { getWhitelabelsFailure, getWhitelabelsSuccess } from "../../Action";
import { setLocalStorageItem } from "../../../Utils/Helper";

function* getWhitelabelDetails(action) {
    try {

        const domain = action?.payload?.payload
        const { data } = yield API.get(`/getwhitelabel?domainName=${domain}`);
     
        if (action?.payload?.callback) {
            yield call(action.payload.callback, data);
        }
        yield call(setLocalStorageItem,"whitelabelData", JSON.stringify(data?.data));
        if (data?.meta?.code === 200) {
            console.log("inside if true condition")
            yield put(getWhitelabelsSuccess(data?.data));

            if (action?.payload?.callback) {
                yield call(action.payload.callback, data);
            }
        } else {
            
            yield put(getWhitelabelsFailure());
        }
    } catch (error) {
        yield put(getWhitelabelsFailure(error.message));

    }
}

export function* watchGetWhitelabelAPI() {
    yield takeEvery(GET_WHITELABELS, getWhitelabelDetails);
}

export default function* rootSaga() {
    yield all([watchGetWhitelabelAPI()]);
}
